// extracted by mini-css-extract-plugin
export default {"title":"ingredient-list_title__anzor","ingredient__list":"ingredient-list_ingredient__list__9wo-D","ingredients__list":"ingredient-list_ingredients__list__NxkNt"};